<template>
  <div class="customer-edit-quotation-treatment row">
    <div class="col-md-11 d-flex align-items-center justify-content-start">
      <div class="form-check form-check-inline">
        <input type="checkbox" :checked="selected" @input="changeSelected" class="form-check-input"
          :id="'treatment_is_selected_' + treatment.id" />
        <label class="form-check-label" :for="'treatment_is_selected_' + treatment.id">
        </label>
      </div>

      <div>
        <div class="customer-edit-quotation-treatment__name" @click="$emit('edit', treatment)">
          {{ treatment.full_name }}
        </div>
        <div class="customer-edit-quotation-treatment__date">
          {{ treatment_date }}
        </div>
      </div>

      <div v-if="treatment.quotation_id" class="customer-edit-quotation-treatment__status"
        :class="{ approved: is_approved }" @click="approvedClick">
        {{ is_approved ? 'Aprobado' : 'Sin aprobar' }}
      </div>

      <div class="customer-edit-quotation-treatment__is-done" :class="{ done: is_done }"
        @click="$emit('edit', treatment)">
        <span v-if="is_done">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clip-path="url(#clip0_212_2094)">
              <path
                d="M6.31414 13.8661C6.17617 14.0038 5.98919 14.0811 5.79425 14.0811C5.59931 14.0811 5.41233 14.0038 5.27437 13.8661L1.12323 9.71389C1.02078 9.61153 0.939505 9.48997 0.884055 9.35618C0.828604 9.22239 0.800064 9.07898 0.800064 8.93415C0.800064 8.78932 0.828604 8.64592 0.884055 8.51212C0.939505 8.37833 1.02078 8.25678 1.12323 8.15441L1.64294 7.63643C1.74531 7.53398 1.86686 7.4527 2.00065 7.39725C2.13445 7.3418 2.27785 7.31326 2.42268 7.31326C2.56751 7.31326 2.71092 7.3418 2.84471 7.39725C2.9785 7.4527 3.10006 7.53398 3.20242 7.63643L5.79408 10.2264L12.7976 3.22319C12.9 3.12074 13.0215 3.03947 13.1553 2.98402C13.2891 2.92857 13.4325 2.90003 13.5773 2.90003C13.7222 2.90003 13.8656 2.92857 13.9994 2.98402C14.1332 3.03947 14.2547 3.12074 14.3571 3.22319L14.8768 3.7429C14.9792 3.84527 15.0605 3.96682 15.116 4.10062C15.1714 4.23441 15.2 4.37782 15.2 4.52264C15.2 4.66747 15.1714 4.81088 15.116 4.94467C15.0605 5.07846 14.9792 5.20002 14.8768 5.30238L6.31414 13.8661Z"
                fill="#6ECA98" />
            </g>
            <defs>
              <clipPath id="clip0_212_2094">
                <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
              </clipPath>
            </defs>
          </svg>
          Realizado {{ done_date }}
        </span>
        <span v-else>
          Sin Realizar
        </span>
      </div>

      <div class="customer-edit-quotation-treatment__is-done" :class="{ done: is_paid }"
        @click="$emit('edit', treatment)">
        <span v-if="is_paid">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path
              d="M1.76001 10.452L1.76001 8.88399L10.4 8.88399L10.4 10.452L1.76001 10.452ZM1.76001 8.24399L1.76001 6.67599L10.4 6.67599L10.4 8.24399L1.76001 8.24399ZM9.40801 14.388C8.52268 14.388 7.70134 14.2493 6.94401 13.972C6.19734 13.684 5.54668 13.2787 4.99201 12.756C4.44801 12.2333 4.02134 11.62 3.71201 10.916C3.40268 10.2013 3.24801 9.41732 3.24801 8.56399C3.24801 7.71066 3.40268 6.93199 3.71201 6.22799C4.02134 5.51332 4.44801 4.89466 4.99201 4.37199C5.54668 3.84932 6.19734 3.44932 6.94401 3.17199C7.70134 2.88399 8.52268 2.73999 9.40801 2.73999C10.4427 2.73999 11.3653 2.92132 12.176 3.28399C12.9973 3.64666 13.68 4.16933 14.224 4.85199L12.208 6.67599C11.856 6.24932 11.4613 5.92399 11.024 5.69999C10.5867 5.47599 10.1013 5.36399 9.56801 5.36399C9.10934 5.36399 8.68801 5.43866 8.30401 5.58799C7.93068 5.73732 7.60534 5.95599 7.32801 6.24399C7.05068 6.52132 6.83201 6.85732 6.67201 7.25199C6.52268 7.64666 6.44801 8.08399 6.44801 8.56399C6.44801 9.04399 6.52268 9.48132 6.67201 9.87599C6.83201 10.2707 7.05068 10.612 7.32801 10.9C7.60534 11.1773 7.93068 11.3907 8.30401 11.54C8.68801 11.6893 9.10934 11.764 9.56801 11.764C10.1013 11.764 10.5867 11.652 11.024 11.428C11.4613 11.204 11.856 10.8787 12.208 10.452L14.224 12.276C13.68 12.948 12.9973 13.4707 12.176 13.844C11.3653 14.2067 10.4427 14.388 9.40801 14.388Z"
              fill="#42B577" />
          </svg>
          Pagado {{ paid_date }}
        </span>
        <span v-else>
          Sin Pagar
        </span>
      </div>

      <div class="customer-edit-quotation-treatment__doctors" @click="$emit('edit', treatment)">
        <div v-if="treatment.doctor_id">
          Asignado a: {{ doctor_name }}
        </div>
        <div v-else>
          Sin asignar
        </div>
        <div v-if="treatment.derived_by">
          Derivado por: {{ derived_by_name }}
        </div>
      </div>

    </div>
    <div class="col-md-1 d-flex align-items-center justify-content-end">

      <div class="customer-edit-quotation-treatment__price mx-1">
        <strong data-toggle="tooltip" :title="total_paid">
          {{ quoted_price }}
        </strong>
      </div>

      <div class="customer-edit-quotation-treatment__handle">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M8.20023 2.80013C8.20023 3.79431 7.39428 4.60025 6.4001 4.60025C5.40592 4.60025 4.59998 3.79431 4.59998 2.80013C4.59998 1.80594 5.40592 1 6.4001 1C7.39428 1 8.20023 1.80594 8.20023 2.80013ZM8.20023 9.99979C8.20023 10.994 7.39428 11.7999 6.4001 11.7999C5.40592 11.7999 4.59998 10.994 4.59998 9.99979C4.59998 9.00561 5.40592 8.19966 6.4001 8.19966C7.39428 8.19966 8.20023 9.00561 8.20023 9.99979ZM6.4001 19C7.39428 19 8.20023 18.1941 8.20023 17.1999C8.20023 16.2057 7.39428 15.3997 6.4001 15.3997C5.40592 15.3997 4.59998 16.2057 4.59998 17.1999C4.59998 18.1941 5.40592 19 6.4001 19ZM15.3999 2.80013C15.3999 3.79431 14.5939 4.60025 13.5998 4.60025C12.6056 4.60025 11.7996 3.79431 11.7996 2.80013C11.7996 1.80594 12.6056 1 13.5998 1C14.5939 1 15.3999 1.80594 15.3999 2.80013ZM13.5998 11.7999C14.5939 11.7999 15.3999 10.994 15.3999 9.99979C15.3999 9.00561 14.5939 8.19966 13.5998 8.19966C12.6056 8.19966 11.7996 9.00561 11.7996 9.99979C11.7996 10.994 12.6056 11.7999 13.5998 11.7999ZM15.3999 17.1999C15.3999 18.1941 14.5939 19 13.5998 19C12.6056 19 11.7996 18.1941 11.7996 17.1999C11.7996 16.2057 12.6056 15.3997 13.5998 15.3997C14.5939 15.3997 15.3999 16.2057 15.3999 17.1999Z"
            fill="#A6AAB4" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['treatment', 'selected', 'doctor_names'],
  computed: {
    total_paid() {
      return WabiDent.fmtMoney(this.treatment.paid_amount);
    },
    quoted_price() {
      if (this.treatment.quoted_price > 0) {
        return WabiDent.fmtMoney(this.treatment.quoted_price);
      }

      return 0;
    },
    doctor_name() {
      if (!this.clinic || !this.treatment.doctor_id) return '';
      return this.doctor_names[this.treatment.doctor_id] || '';
    },
    derived_by_name() {
      if (!this.clinic || !this.treatment.derived_by) return '';
      return this.doctor_names[this.treatment.derived_by] || '';
    },
    is_paid() {
      return this.treatment && this.treatment.is_paid && this.treatment.paid_at;
    },
    is_done() {
      return this.treatment && (this.treatment.status == 'done' || this.treatment.status == 'done_prior') && this.treatment.done_at;
    },
    done_date() {
      return window.WabiDent.fmtDate(this.treatment.done_at);
    },
    paid_date() {
      return window.WabiDent.fmtDate(this.treatment.paid_at);
    },
    is_approved() {
      return this.treatment.is_approved;
    },
    treatment_date() {
      return moment(this.treatment.created_at).format('DD/MM/YY');
    },
    ...mapGetters(['clinic'])
  },
  methods: {
    changeSelected(ev) {
      this.$emit('select', ev.target.checked, this.treatment.id);
    },
    approvedClick() {
      this.$emit('approve', this.is_approved, this.treatment.id);
    }
  }
}
</script>


<style lang="scss">
.customer-edit-quotation-treatment {
  background: #F9F9F8;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 17px 10px;

  &__name {
    font-family: Sarabun;
    font-size: 15px;
    font-weight: 700;
    cursor: pointer;
    transition: .3s;

    &:hover {
      color: var(--theme-color);
    }
  }

  &__date {
    color: var(--texto-gris, #A6AAB4);
    font-size: 12px;
    font-weight: 700;
  }

  &__handle {
    cursor: grab;
  }

  &__status {
    cursor: pointer;
    border-radius: 20px;
    background: var(--ui-gris-oscuro, #EDEFF2);
    padding: 4px 10px;
    color: var(--texto-gris, #A6AAB4);
    font-size: 12px;
    font-weight: 700;
    transition: .2s ease;
    margin-left: 20px;

    &.approved {
      background: var(--texto-azul-planificado, #72B4E4);
      color: white;
    }
  }

  &__doctors {
    color: var(--theme-text-color);
    font-size: 12px;
    font-weight: 700;
    position: relative;
    padding-left: 10px;
    margin-left: 5px;

    &::before {
      width: 2px;
      height: 15px;
      vertical-align: middle;
      margin: 0 10px;
      background: var(--texto-gris, #A6AAB4);
      content: '';
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
      display: inline-block;
      position: absolute;
    }
  }

  &__is-done {
    color: var(--texto-gris, #A6AAB4);
    font-size: 12px;
    font-weight: 700;
    margin: 5px;

    &.done {
      color: #42B577;
    }
  }
}
</style>
